import React, { useState } from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { richText } from '../../util/richText';
import { sanitizeHtml } from '../../util/sanitize';
import { Heading, Modal } from '../../components';

import css from './SectionDescriptionExpandable.module.css';

const MIN_LENGTH_FOR_LONG_WORDS = 20;
const ALLOWED_HTML_TAG_REGEX = /<\/?(p|strong|em|u|s|ul|ol|li|blockquote|br|hr)\b[^>]*>/i;

const renderText = (text, className) => {
  if (!text) return null;
  const isHtml = ALLOWED_HTML_TAG_REGEX.test(text);
  if (isHtml) {
    const cleanHtml = sanitizeHtml(text);
    return <div className={className} dangerouslySetInnerHTML={{ __html: cleanHtml }} />;
  }
  return (
    <p className={className}>
      {richText(text, {
        linkify: true,
        longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
        breakChars: '/',
      })}
    </p>
  );
};

/**
 * 4-line clamped description with "Show more" -> Modal containing full text.
 *
 * Props:
 *   - text: string
 *   - onManageDisableScrolling
 */
const SectionDescriptionExpandable = props => {
  const { text, onManageDisableScrolling } = props;
  const [isOpen, setIsOpen] = useState(false);

  if (!text) return null;

  return (
    <section className={css.root}>
      <div className={css.clamp}>{renderText(text, css.body)}</div>
      <button type="button" className={css.showMore} onClick={() => setIsOpen(true)}>
        <FormattedMessage id="ListingPage.showMore" />
      </button>
      <Modal
        id="ListingPage.descriptionExpandable"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        usePortal
        onManageDisableScrolling={onManageDisableScrolling || (() => {})}
      >
        <Heading as="h2" rootClassName={css.modalTitle}>
          <FormattedMessage id="ListingPage.descriptionModalTitle" />
        </Heading>
        <div className={css.modalBody}>{renderText(text, css.body)}</div>
      </Modal>
    </section>
  );
};

export default SectionDescriptionExpandable;
